import { defineStore } from "pinia";

interface State {
  messages: Record<string, string>;
}
export const useLoadingStore = defineStore("loading", {
  state: (): State => ({
    messages: {},
  }),
  getters: {},
  actions: {
    updateLoadingMessage(id: string, message: string) {
      this.messages[id] = message;
    },
  },
});
